<template>
  <div class="scenario_option nine">
    <label
        v-for="option in options"
        :class="['option_box']"
    >
      <input type="checkbox"
             :value=option.value
             v-model="option.selected"
             @click="selectMany(option.id)"
      >
      <span>{{ option.label }}</span>
    </label>
  </div>

</template>

<script>
import {dispatch} from "vuex-pathify";


export default {
  name: "multiple_choice",
  props: {
    options: Array,
    page_no: Number
  },
  methods: {
    selectMany(id = null) {
      let selectedArr = []
      this.options.forEach(item => {
        if (item.id === id) {
          item.selected = !item.selected
        }
        if (item.selected) {
          selectedArr.push(item)
        }
      })
      let moduleName = store.get('moduleName')
      dispatch(`${moduleName}/setPostData`, {page_no: this.page_no, page_answer: selectedArr})
    }
  },
  created() {
    this.selectMany()
  }
}
</script>

<style scoped>

</style>